"use client";

import { useCheckboxCheck } from "../__chunks/AJFF2SUZ.js";
import "../__chunks/EYKMH5G5.js";
import { SelectItemCheckedContext } from "../__chunks/SLHXTMPQ.js";
import "../__chunks/APGXEJ2Q.js";
import "../__chunks/G4PVPWEW.js";
import "../__chunks/COWZSPJ7.js";
import "../__chunks/CMXOY7UW.js";
import "../__chunks/JDEWEW7S.js";
import { createElement, createHook, forwardRef } from "../__chunks/7FZLUSKW.js";
import "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadProps, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/select/select-item-check.tsx
import { useContext } from "react";
var TagName = "span";
var useSelectItemCheck = createHook(function useSelectItemCheck2(_a) {
  var _b = _a,
    store = _b.store,
    checked = _b.checked,
    props = __objRest(_b, ["store", "checked"]);
  var context = useContext(SelectItemCheckedContext);
  checked = checked != null ? checked : context;
  props = useCheckboxCheck(__spreadProps(__spreadValues({}, props), {
    checked: checked
  }));
  return props;
});
var SelectItemCheck = forwardRef(function SelectItemCheck2(props) {
  var htmlProps = useSelectItemCheck(props);
  return createElement(TagName, htmlProps);
});
export { SelectItemCheck, useSelectItemCheck };